import { useDispatch, useSelector } from 'react-redux'

import { EuiPage } from '@elastic/eui'

import { Account } from 'api/interfaces'
import { showSuccessToast, updateAccountState } from 'app/appSlice'
import { RootState } from 'app/rootReducer'

import { AgencyV2ClientPageLayout } from '../../components/layouts/AgencyV2ClientPageLayout'
import { ClientDetailsForm } from './ClientDetailsForm'

export const ClientDetailsPage = () => {
  const dispatch = useDispatch()
  const { currentAccount } = useSelector((state: RootState) => state.app)

  return (
    <EuiPage className='euiPage--platform'>
      <AgencyV2ClientPageLayout helmetTitle={'Client Details'} headerTitle={`Client Details: ${currentAccount?.name}`}>
        <ClientDetailsForm
          isNewAccount={false}
          onSubmit={(account: Account) => {
            dispatch(showSuccessToast('Saved client'))
            dispatch(updateAccountState(account))
          }}
        />
      </AgencyV2ClientPageLayout>
    </EuiPage>
  )
}
